<template>
<div :style="layoutCss">
<!--  Fullscreen image-->
  <div v-if="hint_type == 'image' && gameConfig.is_image_fullscreen && fullscreen">
    <img :style="fullscreenCss" :src="file_url">
  </div>
  <div  v-if="hint_type == 'video' && gameConfig.is_video_fullscreen && fullscreen && showVideo" >
    <video ref="fullscreenVid" :loop="loop_video" :key="'G' + videoKey"
           :style="fullscreenCss" crossorigin="anonymous" autoplay :src="file_url" @ended="handleVideoEnd" @error="handleVideoError">
    </video>
  </div>
  <div class="row mr-5 ml-5" v-show="!fullscreen">
    <div class="col-12">
<!--      <card>-->
      <grid-layout :layout.sync="layout"
                     :col-num="3"
                     :max-rows="4"
                      :row-height="gridRowHeight"
                     :is-draggable="true"
                     :is-resizable="true"
                     :vertical-compact="false"
                     :use-css-transforms="true"
        >
          <grid-item v-for="(item, index) in layout" :key="index + 'B'"
                     static
                     :x="item.x"
                     :is-bounded="true"
                     :y="item.y"
                     :w="item.w"
                     :h="item.h"
                     :i="item.i"
          >
            <div v-if="item.name == 'Timer'" v-show="show_timer" class="text-center clue-display-timer-cell">
              <p :style="{'font-size': gameConfig.font_size + 'px',
              'font-family': gameConfig.font_family, 'color': gameConfig.text_color}">{{hours}}:{{minutes}}:{{seconds}}
              </p>
            </div>
            <div v-if="item.name == 'Logo'" class="text-center"
                 style="height: 100%; display: flex;
                        justify-content: center;
                        align-items: center;">
              <img :style="{'object-fit': 'contain', 'max-height': gridRowHeight * item.h + 'px'}" :src="gameConfig.company_logo">
            </div>
            <div v-if="item.name == 'Hints'" class="text-center" :key="h"
                 style="height: 100%; display: flex;
                        justify-content: center;
                        align-items: center;">
              <i v-for="j in gameConfig.clues_remaining" :key="j + 'C'"
                 :style="{'font-size': gameConfig.hint_icon_font_size + 'px', 'color': gameConfig.available_hint_color}"
                 class="ml-1" :class="'tim-icons ' + gameConfig.icon_style"></i>
              <i v-for="i in gameConfig.clues_used" :key="i  + 'D'"
                 :style="{'font-size': gameConfig.hint_icon_font_size + 'px', 'color': gameConfig.used_hint_color}"
                 class="ml-1" :class="'tim-icons ' + gameConfig.icon_style"></i>
            </div>
            <div v-if="item.name == 'Content'" class="text-center"
                        style="height: 100%; display: flex;
                        justify-content: center;
                        align-items: center;">
<!--              Text-->
              <div v-if="hint_type == 'text' || hint_type == 'custom'" >
                <p v-if="gameConfig.has_timer"
                   :style="{'font-family': gameConfig.hint_text_font, 'font-size': gameConfig.hint_font_size + 'px', 'color': gameConfig.hint_text_color}">
                  {{text_message}}
                </p>
                <p v-else :style="{'font-family': gameConfig.hint_text_font, 'font-size': gameConfig.hint_font_size + 'px', 'margin-top': '300px', 'color': gameConfig.hint_text_color}">
                  {{text_message}}
                </p>
              </div>
<!--              Image-->
              <div v-if="hint_type == 'image' && !gameConfig.is_image_fullscreen">
                <img :style="{'object-fit': 'contain', 'max-height': gridRowHeight * item.h + 'px'}" :src="file_url">
              </div>

<!--              Video-->
              <div class="col" v-if="hint_type == 'video' && !gameConfig.is_video_fullscreen && showVideo">
                <video :loop="loop_video" :style="{'object-fit': 'contain', 'max-height': gridRowHeight * item.h + 'px'}" crossorigin="anonymous"
                       ref="inlineVid" autoplay :key="'F' + videoKey" :src="file_url" @ended="handleVideoEnd" @error="handleVideoError">
                </video>
              </div>
            </div>
          </grid-item>
        </grid-layout>
    </div>
  </div>

  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>
  <link v-if="!loading" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + gameConfig.font_family">
  <link v-if="!loading" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + gameConfig.hint_text_font">

</div>
</template>

<script>
import {API_LOCATION} from "@/api-config";
import axios from "axios";
import VueGridLayout from 'vue-grid-layout';
import swal from "sweetalert2";

export default {
  name: "ClueDisplay",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  },
  data() {
    return {
      background_image: [],
      layout: [
        {"x":0,"y":1,"w":3,"h":3,"i":"3", "name": "Content"},
      ],
      fullscreenCss: '',
      row_height: 210,
      layoutCss: '',
      fullscreen: false,
      loading: false,
      loop_video: false,
      gameConfig: '',
      text_message: '',
      show_timer: true,
      file_url: '',
      data: '',
      type: '',
      hint_type: '',
      h: 0,
      videoKey: 0,
      hours: '00',
      seconds: '00',
      minutes: '00',
      totalSeconds: 0,
      timerEnabled: false,
      originalTotalSeconds: 0,
      timerAnchor: null,       // wall-clock ms when timer started/resumed
      anchorSeconds: 0,        // totalSeconds at the moment of anchoring
      timerInterval: null,     // setInterval id for display refresh
      backgroundAudio: null,
      showVideo: true,
      isIntroVideo: false,
      timerSpeed: 1
    }
  },
  created(){
    this.startWebSocket()
    window.addEventListener("resize", this.setLayoutCss);
  },
  beforeDestroy(){
    this.stopCountdown()
    if (this.socket) {
      this.socket.close();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.setLayoutCss);
  },
  watch: {
    timerEnabled(value) {
      if (value) {
        this.startCountdown()
      } else {
        this.stopCountdown()
      }
    },
  },
  computed: {
    // Single source of truth for the grid row-height so the media max-height
    // (logo/image/video) can never diverge from the row-height the grid is
    // actually laid out with. Portrait keeps its fixed row-height; landscape
    // uses the window-derived value so the 4 rows fill the screen.
    gridRowHeight() {
      return this.gameConfig.is_portrait_mode ? 167 : this.row_height
    },
  },
  methods: {
    startCountdown() {
      if (this.timerInterval) return
      // Anchor: record wall-clock time and the current totalSeconds
      this.timerAnchor = Date.now()
      this.anchorSeconds = this.totalSeconds
      this.timerInterval = setInterval(() => this.tickTimer(), 250)
    },
    stopCountdown() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
      // Freeze totalSeconds at current computed value
      if (this.timerAnchor) {
        let elapsedMs = Date.now() - this.timerAnchor
        let elapsed = Math.max(0, Math.floor((elapsedMs * this.timerSpeed) / 1000))
        this.totalSeconds = Math.max(0, this.anchorSeconds - elapsed)
        this.timerAnchor = null
        this.updateTimerDisplay()
      }
    },
    tickTimer() {
      if (!this.timerEnabled || !this.timerAnchor) return

      let elapsedMs = Date.now() - this.timerAnchor
      let elapsed = Math.max(0, Math.floor((elapsedMs * this.timerSpeed) / 1000))
      let current = this.anchorSeconds - elapsed

      // Stop at zero — null anchor first so stopCountdown won't recalculate
      if (current <= 0) {
        this.totalSeconds = 0
        this.updateTimerDisplay()
        clearInterval(this.timerInterval)
        this.timerInterval = null
        this.timerAnchor = null
        this.timerEnabled = false
        return
      }

      // Guard against going above original (shouldn't happen in countdown)
      if (current > this.originalTotalSeconds + 1) {
        this.totalSeconds = 0
        this.updateTimerDisplay()
        clearInterval(this.timerInterval)
        this.timerInterval = null
        this.timerAnchor = null
        this.timerEnabled = false
        return
      }

      this.totalSeconds = current
      this.updateTimerDisplay()
    },
    updateTimerDisplay() {
      let clamped = Math.max(0, this.totalSeconds)
      let h = Math.floor(clamped / 3600)
      let m = Math.floor((clamped % 3600) / 60)
      let s = clamped % 60
      this.hours = String(h).padStart(2, '0')
      this.minutes = String(m).padStart(2, '0')
      this.seconds = String(s).padStart(2, '0')
    },
    handleVideoEnd(){
      let wasIntroVideo = this.isIntroVideo
      if(wasIntroVideo && this.socket && this.socket.readyState === WebSocket.OPEN){
        let message = JSON.stringify({
          action: 'sendclue',
          gameId: this.$route.query.gameId,
          data: '',
          type: 'intro_video_ended',
          clue_id: '',
          count_as_hint: 0
        })
        this.socket.send(message)
        this.isIntroVideo = false
      }
      if(wasIntroVideo || this.gameConfig.clear_video_hints){
        this.showVideo = false
        this.fullscreen = false
      }
    },
    handleVideoError(){
      this.handleVideoEnd()
      this.showVideo = false
      this.fullscreen = false
      this.hint_type = ''
    },
    startWebSocket(){
      let id = this.$route.query.gameId
      // if(localStorage.getItem("selectedGameDetailsForClues") && JSON.parse(localStorage.getItem("selectedGameDetailsForClues")).hasOwnProperty('id')){
      //   id = JSON.parse(localStorage.getItem("selectedGameDetailsForClues")).id
      // } else {
      //   id = this.$route.query.gameId
      // }
      let url = 'wss://3bqa7hkquf.execute-api.us-east-1.amazonaws.com/production?gameId=' +  id
      this.socket = new WebSocket(url);

      this.socket.onopen = () => {};

      this.socket.onmessage = (event) => {
        this.event = event.data
        this.loadMessage(this.event)
      };

      this.socket.onclose = () => {
        this.socket = null
        this.startWebSocket()
      };

      this.socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };
    },
    loadMessage(msg){
      this.type = JSON.parse(msg).type
      if(this.type === 'intro_video_ended') return

      // Completion media - detect audio vs video from URL, play accordingly
      if(this.type === 'completion_media'){
        let mediaUrl = JSON.parse(msg).data
        let audioExtensions = ['.mp3', '.wav', '.ogg', '.aac', '.m4a', '.flac', '.wma']
        let isAudio = audioExtensions.some(ext => mediaUrl.split('?')[0].toLowerCase().endsWith(ext))

        if (isAudio) {
          let audio = new Audio(mediaUrl)
          audio.play()
          this.hint_type = 'clear'
        } else {
          this.showVideo = true
          this.fullscreen = false
          this.file_url = mediaUrl
          this.loop_video = false
          this.videoKey++
          if(this.gameConfig.is_video_fullscreen){
            this.fullscreen = true
          }
          this.hint_type = 'video'
        }
        return
      }

      //background music
      if(this.type === 'start_background_music'){
        if(this.gameConfig.loop_background_music === 1){
          this.backgroundAudio.loop = true
        } else {
          this.backgroundAudio.loop = false
        }
        this.backgroundAudio.play();
      }
      if(this.type === 'pause_background_music'){
        this.backgroundAudio.pause();
      }

      if(this.type == 'image'){
        this.fullscreen = false

        //Play pre hint sound
        if(this.gameConfig.play_sound_before_hints == true && this.gameConfig.play_sound_before_img == true && this.gameConfig.pre_hint_sound_file){
          let audio = new Audio(this.gameConfig.pre_hint_sound_file);
          audio.play();
        }
        this.file_url = JSON.parse(msg).data

        if(this.gameConfig.is_image_fullscreen){
          this.fullscreen = true
        }
        this.hint_type = this.type
      }
      if(this.type == 'audio'){
        this.fullscreen = false
        if(this.gameConfig.play_sound_before_hints == true && this.gameConfig.play_sound_before_audio == true && this.gameConfig.pre_hint_sound_file){
          let audio = new Audio(this.gameConfig.pre_hint_sound_file);
          audio.play();
          setTimeout(() => {
            this.file_url = JSON.parse(msg).data
            let audio = new Audio(this.file_url);
            audio.play();
          }, 1000)

        } else {

          this.file_url = JSON.parse(msg).data
          let audio = new Audio(this.file_url);
          audio.play();
        }
        this.hint_type = this.type
      }
      if(this.type == 'video'){
        this.showVideo = true
        this.fullscreen = false
        this.isIntroVideo = this.gameConfig.intro_video_url && JSON.parse(msg).data === this.gameConfig.intro_video_url
        if(!this.isIntroVideo && this.gameConfig.play_sound_before_hints == true && this.gameConfig.play_sound_before_video == true && this.gameConfig.pre_hint_sound_file){
          //this.hint_type = this.type
          let audio = new Audio(this.gameConfig.pre_hint_sound_file);
          audio.play();
          setTimeout(() => {
            this.file_url = JSON.parse(msg).data
            this.videoKey++
          }, 1000)
        } else {
          //this.hint_type = this.type
          this.file_url = JSON.parse(msg).data
          this.loop_video = Boolean(JSON.parse(msg).loop)
          this.videoKey++
        }

        if(this.gameConfig.is_video_fullscreen){
          this.fullscreen = true
        }
        this.hint_type = this.type
      }
      this.data = JSON.parse(msg)
      if(this.type == 'new_timer_value'){
        this.stopCountdown()
        this.timerEnabled = false
        const hours = parseInt(this.data.data.split(':')[0])
        const minutes = parseInt(this.data.data.split(':')[1])
        this.gameConfig.max_time = hours + ": " + minutes + ":00"
        this.totalSeconds = (hours * 3600) + (minutes * 60)
        this.originalTotalSeconds = this.totalSeconds + 2
        this.updateTimerDisplay()
        return
      }
      if(this.type == 'adjust_timer'){
        const parts = this.data.data.split(':')
        const h = parseInt(parts[0]) || 0
        const m = parseInt(parts[1]) || 0
        const s = parseInt(parts[2]) || 0
        const newTotalSeconds = (Math.abs(h) * 3600) + (m * 60) + s
        this.totalSeconds = parts[0].startsWith('-') ? -newTotalSeconds : newTotalSeconds
        this.originalTotalSeconds = this.totalSeconds + 2
        this.updateTimerDisplay()

        if (this.timerEnabled && this.timerAnchor) {
          this.timerAnchor = Date.now()
          this.anchorSeconds = this.totalSeconds
        }
        return
      }
      if(this.type == 'timer_speed'){
        this.timerSpeed = parseFloat(this.data.data) || 1
        return
      }
      if(this.type == 'timer'){
        if(this.data.data == 'start'){
          if(!this.gameConfig.auto_sync){
            this.timerEnabled = true
            this.startCountdown()
          }

        } else if(this.data.data == 'reset') {
          this.timerEnabled = false
          let h = parseInt(this.gameConfig.max_time.split(':')[0])
          let m = parseInt(this.gameConfig.max_time.split(':')[1])
          let s = parseInt(this.gameConfig.max_time.split(':')[2])
          this.totalSeconds = (h * 3600) + (m * 60) + s
          this.originalTotalSeconds = this.totalSeconds + 2
          this.updateTimerDisplay()

        } else if(this.data.data == 'show') {
          this.show_timer = true
        } else if(this.data.data == 'hide') {
          this.show_timer = false
        } else {
          this.timerEnabled = false

        }
        return
      }
      if(this.type == 'text' || this.type == 'custom'){
        this.fullscreen = false
        if(this.type == 'custom' && this.gameConfig.play_sound_before_hints == true && this.gameConfig.play_sound_before_custom == true && this.gameConfig.pre_hint_sound_file){
          let audio = new Audio(this.gameConfig.pre_hint_sound_file);
          audio.play();
        }
        if(this.type == 'text' && this.gameConfig.play_sound_before_hints == true && this.gameConfig.play_sound_before_text == true && this.gameConfig.pre_hint_sound_file){
          let audio = new Audio(this.gameConfig.pre_hint_sound_file);
          audio.play();
        }
        this.hint_type = this.type
        this.text_message = JSON.parse(msg).data
      }

      if((JSON.parse(msg).count_as_hint || this.type === 'sync') && this.gameConfig.clues_remaining > 0
        && this.type != 'extra_hint'
        && this.type != 'remove_extra_hint'
        && this.type != 'clear'
        && JSON.parse(msg).type != 'reset_hints'
        && JSON.parse(msg).type != 'remove_hint'){
        this.gameConfig.clues_remaining = parseInt(this.gameConfig.clues_remaining) - 1
        this.gameConfig.clues_used = parseInt(this.gameConfig.clues_used) + 1
        this.h++
      }

      if(this.type == 'clear'){
        this.fullscreen = false
        this.hint_type = this.type
      }

      if(this.type == 'extra_hint'){
        this.gameConfig.clues_remaining = parseInt(this.gameConfig.clues_remaining) + 1
        this.h++
      }
      if(JSON.parse(msg).type == 'remove_extra_hint'){
        this.gameConfig.clues_remaining = parseInt(this.gameConfig.clues_remaining) - 1
        this.gameConfig.clues_remaining = this.gameConfig.clues_remaining > 0 ? this.gameConfig.clues_remaining : 0
        this.h++
      }
      else if(JSON.parse(msg).type == 'reset_hints'){
        this.gameConfig.clues_remaining = parseInt(this.gameConfig.max_clues)
        this.gameConfig.clues_used = 0
        this.h++
      } else if (JSON.parse(msg).type == 'remove_hint'){
        if(parseInt(this.gameConfig.clues_used) > 0){
          this.gameConfig.clues_used--
          this.gameConfig.clues_remaining++
        }
        this.h++
      }
      if(JSON.parse(msg).type == 'sync'){
        // Stop current countdown before updating values
        this.stopCountdown()
        this.timerEnabled = false

        let h = parseInt(this.data.data.timer.split(':')[0])
        let m = parseInt(this.data.data.timer.split(':')[1])
        let s = parseInt(this.data.data.timer.split(':')[2])
        this.totalSeconds = (h * 3600) + (m * 60) + s
        this.originalTotalSeconds = this.totalSeconds + 2
        this.updateTimerDisplay()

        if(!this.gameConfig.auto_sync){
          if(this.data.data.timer_active){
            this.timerEnabled = true
            this.startCountdown()
          }
        }
        this.time_status = 'start'
        this.gameConfig.clues_used = this.data.data.clues_used
        this.gameConfig.clues_remaining = this.data.data.clues_remaining
      }
    },
    setLayoutCss(){
      let windowHeight = window.innerHeight;

      // The grid uses a fixed pixel row-height, so the 4 rows only fill the
      // screen vertically if the row-height tracks the window. Without this the
      // grid stays ~890px tall anchored at the top, pushing anything placed low
      // (e.g. the content cell) up toward the middle on taller displays. The
      // editor sizes its canvas to exactly fit 4 rows, so deriving row-height
      // the same way here keeps the live view matching what was configured.
      const maxRows = 4
      const gridMarginY = 10
      this.row_height = Math.max(1, (windowHeight - (maxRows + 1) * gridMarginY) / maxRows)

      if(this.gameConfig.display_background_image){
        let url = this.gameConfig.img
        if(this.background_image.length > 0){
          url = this.background_image[0].url
        }

        // background-size must live in its own longhand: an empty-string
        // longhand in the same style object erases the size set by the
        // shorthand, dropping the image back to natural size.
        const fitMap = {
          'cover': 'cover',
          'fill': '100% 100%',
          'contain': 'contain',
          'scale-down': 'contain',
          'none': 'auto'
        }
        let size = 'cover'
        let additional_image_formatting = ''
        if(this.background_image.length > 0){
          size = fitMap[this.background_image[0].object_fit] || 'cover'
          additional_image_formatting = this.background_image[0].background_color + ' no-repeat center'
        }

        this.layoutCss = { 'background': 'url('+ url + ') '
            + additional_image_formatting, 'overflow': 'hidden',
          'position' : 'absolute',
          'top' : '0px',
          'right' : '0px',
          'bottom':'0px',
          'left':'0px',
          'background-size': size,
          'height': windowHeight + 'px', 'overflow-x': 'hidden'}

      } else {
        this.layoutCss = {'background-color': this.gameConfig.background_color, 'height': windowHeight + 'px', 'overflow-x': 'hidden'}
      }

      this.fullscreenCss = {
        'width': '100%',
        'height': windowHeight + 'px',
        'padding': '0',
        'margin': '0',
        'object-fit': 'contain'
      }
    },
    async getGameConfigurations(){
      let gameId = this.$route.query.gameId
      this.loading = true
      let companyId = localStorage.getItem('companyId')
      let url = API_LOCATION + 'companies/' + companyId + '/games/' + gameId + '/clue-display-configurations'
      axios.get(url)
        .then(response => {
          this.loading = false
          this.gameConfig = response.data.configurations
          this.background_image = response.data.background_image
          this.layout = response.data.layout
          this.setLayoutCss()
          this.gameConfig.clues_used = 0
          this.gameConfig.clues_remaining = parseInt(this.gameConfig.max_clues) - parseInt(this.gameConfig.clues_used)

          this.hours = ('0' +  parseInt(this.gameConfig.max_time.split(':')[0])).slice(-2)
          this.minutes = ('0' +  parseInt(this.gameConfig.max_time.split(':')[1])).slice(-2)
          this.seconds = ('0' +  parseInt(this.gameConfig.max_time.split(':')[2])).slice(-2)
          this.totalSeconds = (parseInt(this.hours) * 3600) + (parseInt(this.minutes) * 60) + parseInt(this.seconds)
          this.originalTotalSeconds = (parseInt(this.hours) * 3600) + (parseInt(this.minutes) * 60) + parseInt(this.seconds) + 2

          if(this.gameConfig.play_background_music){
            this.backgroundAudio = new Audio(this.gameConfig.background_music_sound_file);
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
  },
  mounted(){
    this.getGameConfigurations()
  }
}
</script>

<style scoped>
.clue-display-timer-cell {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
